import { IResumenAccidentabilidadModel } from "../interfaces/ficha-sso/IResumenAccidentabilidadModel";

export class ResumenAccidentabilidadModel implements IResumenAccidentabilidadModel{
    idResumenAccidentabilidad: number;
    idGbu: number;
    idGbuSelected?: number;
    gbu: string;
    idProyecto?: number;
    proyecto?: string;
    idCategoriaHipo: number;
    idCategoriaHipoSelected?: number;
    categoriaHipo: string;
    fechaEvento: Date;
    textoIdentificativo: string;
    descripcion: string;
    cliente: string;
    idTipoRegla: number;
    idTipoReglaSelected?: number;
    tipoRegla: string;    
    tiempoPerdido?: boolean;
    tiempoPerdidoSelected?: number;
    nroDiasPerdidos?: number;
    idTipoEmpleado: number;
    idTipoEmpleadoSelected?: number;
    tipoEmpleado: string;
    idTipoAccidente: number;
    idTipoAccidenteSelected?: number;
    tipoAccidente: string;
    editable: boolean;
    index: number;  

    constructor(){
        this.idResumenAccidentabilidad = 0;
        this.idGbu = 0;
        this.gbu = '';
        this.idCategoriaHipo = 0;
        this.categoriaHipo = '';
        this.fechaEvento = new Date();
        this.textoIdentificativo = '';
        this.descripcion = '';
        this.cliente = '';
        this.idTipoRegla = 0;
        this.tipoRegla = '';
        this.idTipoEmpleado = 0;
        this.tipoEmpleado = '';
        this.idTipoAccidente = 0;
        this.tipoAccidente = '';
        this.editable = false;
        this.index = 0;
    }
}